import * as yup from "yup";
import BaseForm from "../../../../../shared/components/form/BaseForm";
import FormSelect from "../../../../../shared/components/select/FormSelect";

const AddRoleToUserForm = ({ onSubmitHandler, roles }) => {
  const validationSchema = yup.object({
    role: yup.string().required("El rol el obligatorio"),
  });

  const defaultValues = {
    role: "",
  };

  return (
    <BaseForm
      onSubmitHandler={onSubmitHandler}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
    >
      <FormSelect
        name="role"
        label="Rol"
        options={roles?.map((x) => {
          return { label: x.name, value: x.id };
        })}
        required
      />
    </BaseForm>
  );
};

export default AddRoleToUserForm;
